import { render, staticRenderFns } from "./TypeCompte.vue?vue&type=template&id=95cb059e"
import script from "./TypeCompte.vue?vue&type=script&lang=js"
export * from "./TypeCompte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports